var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagMex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.669,
    height: 24.669,
    viewBox: "0 0 24.669 24.669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag-for-mexico-svgrepo-com",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8975",
    "data-name": "Trazado 8975",
    d: "M50.223,15.336A12.294,12.294,0,0,0,42,3.7V26.971a12.294,12.294,0,0,0,8.223-11.636",
    transform: "translate(-23.554 -1.001)",
    fill: "#ed4c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8976",
    "data-name": "Trazado 8976",
    d: "M2,15.336a12.35,12.35,0,0,0,8.223,11.636V3.7A12.35,12.35,0,0,0,2,15.336Z",
    transform: "translate(0 -1.001)",
    fill: "#75a843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8977",
    "data-name": "Trazado 8977",
    d: "M30.223,2.7A12.442,12.442,0,0,0,22,2.7V25.97a12.442,12.442,0,0,0,8.223,0V2.7",
    transform: "translate(-11.777)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27034",
    "data-name": "Grupo 27034",
    transform: "translate(10.7 13.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8978",
    "data-name": "Trazado 8978",
    d: "M35.577,31.347c-.041-.123-.082.041-.082.082a.547.547,0,0,0-.123-.329.618.618,0,0,0-.164.452c-.041-.123-.082-.247-.206-.288.082.123.041.206.041.329,0,.164.123.288.123.452a.571.571,0,0,1-.206.411v-.123c-.411.164-.329.37-.329.74s-.206.288-.452.493a.351.351,0,0,0,0-.288c0,.247-.329.247-.37.452-.041.082,0,.247-.123.288-.082.041-.206.123-.206.206a.61.61,0,0,0-.288-.041c.041-.041.082-.041.123-.082-.411-.206-.534.247-.9.288-.123,0-.411-.164-.411,0,.37,0,.534.329.822.329.247,0,.452-.206.7-.206a1.275,1.275,0,0,0-.288-.082c.206-.123.329-.37.576-.37.411,0,.617-.082.74-.493a.151.151,0,0,0-.123.041.608.608,0,0,1,.329-.452c.411-.082.37-.411.617-.7a.355.355,0,0,0-.247.123c0-.247-.041-.493.164-.658.411-.206.37-.288.288-.576M34.631,33.4",
    transform: "translate(-28.365 -31.1)",
    fill: "#75a843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8979",
    "data-name": "Trazado 8979",
    d: "M23.217,31.347c-.082.329-.123.411.206.617.247.164.164.411.164.658a.293.293,0,0,0-.247-.123c.247.247.206.617.617.7.123.082.329.288.329.452-.041,0-.082-.041-.123-.041.123.411.329.493.74.493.247,0,.37.247.576.37a.479.479,0,0,0-.288.082c.247,0,.452.247.7.206.288,0,.493-.329.822-.329,0-.164-.288,0-.411,0-.329-.082-.452-.493-.9-.329.041.041.082.082.123.082-.082,0-.206-.041-.288.041a.5.5,0,0,0-.206-.206c-.082-.082-.082-.206-.123-.288-.082-.206-.37-.247-.37-.452a.351.351,0,0,0,0,.288c-.247-.206-.452-.123-.452-.493,0-.329.082-.576-.329-.74v.123a.506.506,0,0,1-.206-.411c0-.164.164-.288.123-.452,0-.123-.041-.206.041-.329-.123.041-.164.164-.206.288a.618.618,0,0,0-.164-.452,2.832,2.832,0,0,0-.123.329c.041-.082,0-.206,0-.082m.946,2.056",
    transform: "translate(-23.159 -31.1)",
    fill: "#75a843"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8980",
    "data-name": "Trazado 8980",
    d: "M30.4,36.581c-.082,0-.123-.082-.164-.123,0-.082.329-.164.37-.164v-.082c-.534.164-2.138.288-2.467-.288-.164.247-.452.082-.74-.123.041.082.206.493.206.452.082.041.617.164.617.288l-.123.123a2.534,2.534,0,0,0,2.3-.082",
    transform: "translate(-14.957 -19.903)",
    fill: "#428bc1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8981",
    "data-name": "Trazado 8981",
    d: "M31.4,36.8c.041-.041.041-.082.041-.164l-.041-.123c.082-.082,0-.288-.123-.247-.082.041-.041.041-.123,0-.041,0-.041-.041-.082-.041h-.74c-.082,0-.082-.041-.164-.041-.082-.041-.123.041-.164.082,0,.082.041.082.041.123s-.041.082-.041.164a.214.214,0,0,0,.082.164c-.164.123,0,.329.164.206.041.082.164.082.288.082h.452c.082,0,.247.041.288-.082.123.206.288-.041.123-.123",
    transform: "translate(-16.488 -20.123)",
    fill: "#ed4c5c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8982",
    "data-name": "Trazado 8982",
    d: "M30.18,33.564c-.329-.411-.493.206-.863.164.082-.493-.658-.329-.863-.206a.9.9,0,0,0,.123-.206c-.164,0-.37.082-.493-.041-.247-.164-.576-.247-.781.041-.164-.247-.617-.493-.863-.247,0-.247-.247-.617-.534-.576-.329.041-.206.452-.041.617a.618.618,0,0,0,.452.164.214.214,0,0,0,.082.164.749.749,0,0,0,.822.041c0,.411.822.411,1.028.206-.082.206-.164.617.123.617.247,0,.164-.247.37-.329a.615.615,0,0,1,.534-.041c.288.164,1.192.123.9-.37",
    transform: "translate(-13.954 -17.955)",
    fill: "#428bc1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27035",
    "data-name": "Grupo 27035",
    transform: "translate(11.903 11.708)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8983",
    "data-name": "Trazado 8983",
    d: "M27.038,30.434a.767.767,0,0,0-.123-.164c-.164.041-.164-.082-.206-.206-.041-.206-.329-.288-.329-.452s.164-.329.041-.493-.329-.247-.329-.164c-.041.082.164.082.164.288,0,.247-.247.452.041.658.164.247.164.7.452.7a.275.275,0,0,0,.288-.164",
    transform: "translate(-26.087 -27.56)",
    fill: "#75a843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8984",
    "data-name": "Trazado 8984",
    d: "M28.371,29.286c-.082-.164,0-.411-.164-.534-.206-.164-.617.164-.658-.247a2.508,2.508,0,0,1,.534-.617.425.425,0,0,0-.041-.534c-.164-.082-.206,0-.329.164.041.041.206.123.206.164-.123.288-.493.329-.576.617a.568.568,0,0,0,.164.658.494.494,0,0,0,.329.082c.37-.041.164.041.206.123,0,.082.123.37.329.123",
    transform: "translate(-26.803 -26.618)",
    fill: "#75a843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8985",
    "data-name": "Trazado 8985",
    d: "M26.833,26.264c0,.247.247.206.411.164a.521.521,0,0,1,.041-.247.259.259,0,0,1-.247,0c-.123-.082.288-.247.247-.247,0,0-.411.206-.247-.041.041-.082.123-.164.164-.247s-.123,0-.123,0a.151.151,0,0,0-.123.041c-.247.206-.164.329-.123.576",
    transform: "translate(-26.499 -25.611)",
    fill: "#75a843"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8986",
    "data-name": "Trazado 8986",
    d: "M32.091,25.316A3.128,3.128,0,0,0,29.994,24a3.029,3.029,0,0,0-.576.164c-.37.247.411.452.452.617,0,.082.041.123.041.206-.123-.206-.247-.329-.288-.411a.458.458,0,0,1-.576-.247.548.548,0,0,1-.123.206c0-.123-.041-.123-.082-.206,0,.123,0,.288-.123.329a.272.272,0,0,0-.041-.247.347.347,0,0,1-.082.288c.041-.082-.041-.123-.041-.206-.041.329-.493.452-.041.576.164.041.247,0,.411.082.041.041.123.123.123.082,0,.041-.164.206-.041.247a2.359,2.359,0,0,0-.164.288c.123,0,.041.082-.041.164-.123.206,0,.411.041.658,0-.082.123.041.123.164,0,.164.164.247.206.37-.206-.206-.247,0,0,.123-.206,0-.247.123-.041.206-.493,0-.082.206,0,.247a.542.542,0,0,0,.576-.206s.658.658.7.658.37-.164.452-.082c.082.123.164,0,.247.041.082.082.411,0,.493-.041.041,0,.452-.082.37-.164-.206-.164-.452-.329-.658-.493a7.03,7.03,0,0,1-.576-.452c-.082-.082-.082-.247-.123-.37.37.37.74.576.7-.123a10.629,10.629,0,0,1,.781,1.357c.123,0,0-1.233,0-1.357.164.164.164,1.521.206,1.521.206.041.493-1.768-.206-2.672",
    transform: "translate(-15.495 -12.955)",
    fill: "#89664c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27036",
    "data-name": "Grupo 27036",
    transform: "translate(12.608 12.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8987",
    "data-name": "Trazado 8987",
    d: "M28.95,31.822a.99.99,0,0,1-.247-.329c.123.493-.37.206-.247,0-.164-.041-.576.206-.411.452-.082.164.576.041.617-.041.164.37.576-.041.288-.082",
    transform: "translate(-27.922 -29.497)",
    fill: "#ffce31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8988",
    "data-name": "Trazado 8988",
    d: "M33.11,34.3c.206-.288-.658-.37-.576-.7-.123.082-.288.37-.452.288-.082-.041-.411.164-.247.288,0-.164.082-.041.206-.082-.041.123-.164.247.041.329-.082-.247.247-.123.206-.247-.082-.082.288-.082.329-.082.123,0,.534.123.37.247a.2.2,0,0,0,.123-.041",
    transform: "translate(-30.149 -30.74)",
    fill: "#ffce31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8989",
    "data-name": "Trazado 8989",
    d: "M28.006,26.667c-.041.082-.206.206-.206.329,0,.082.206.288.288.164-.247-.164.041-.288.164-.288.041,0,.041.082.041.082.041.041.37-.082.329-.164.041-.164-.493-.164-.617-.123m0,0",
    transform: "translate(-27.8 -26.644)",
    fill: "#ffce31"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMex);
export default __webpack_public_path__ + "static/media/flag-mex.6b8f41295bec824fb43ce895ff090948.svg";
export { ForwardRef as ReactComponent };